import {
  calculatePreallocateInfo,
  calculatePreallocationTotal,
  getPreallocateAction,
} from '../utils/preallocate-payment';

export const formatPreallocationFormToMakePaymentTrackEvent = ({
  patient,
  preallocateInfo,
  remainingPatientBalance,
  remainingPatientCredits,
  __useCreditAmount,
}) => {
  const preallocateItemGroups = preallocateInfo.flatMap(
    info => info.itemGroups,
  );

  const currentPatientItemGroups = preallocateInfo
    .filter(i => i.patient.id === patient.id)
    .flatMap(i => i.itemGroups);

  const relativesItemGroups = preallocateInfo
    .filter(i => i.patient.id !== patient.id)
    .flatMap(i => i.itemGroups);

  const currentPatientSelectedItems = currentPatientItemGroups
    .flatMap(i => i.items)
    .filter(i => i.selected);

  const relativesSelectedItems = relativesItemGroups
    .flatMap(i => i.items)
    .filter(i => i.selected);

  return {
    patientId: patient.id,
    outstandingCount: preallocateInfo[0].count,
    outstandingAmount: remainingPatientBalance,
    selectedCount: currentPatientSelectedItems.length,
    selectedAmount: calculatePreallocationTotal(currentPatientItemGroups),
    relationshipRelativeCount: preallocateInfo.length - 1,
    relationshipSelectedChargesCount: relativesSelectedItems.length,
    relationshipSelectedChargesAmount:
      calculatePreallocationTotal(relativesItemGroups),
    totalAmountSelected: calculatePreallocateInfo(preallocateInfo),
    unallocatedAmountAvailable: remainingPatientCredits,
    unallocatedAmountUsed: __useCreditAmount,
    totalDueAmount:
      calculatePreallocateInfo(preallocateInfo) - __useCreditAmount,
    action: getPreallocateAction(preallocateItemGroups, __useCreditAmount),
  };
};
